import { render, staticRenderFns } from "./ProgramDetailsRewardCard.vue?vue&type=template&id=69ae019a&scoped=true"
import script from "./ProgramDetailsRewardCard.vue?vue&type=script&lang=js"
export * from "./ProgramDetailsRewardCard.vue?vue&type=script&lang=js"
import style0 from "./ProgramDetailsRewardCard.vue?vue&type=style&index=0&id=69ae019a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ae019a",
  null
  
)

export default component.exports